export type EnumValueNamePair = { value: number; name: string };

/* eslint-disable @typescript-eslint/no-unused-vars */
export class Misc {
    public static privateSurfing: boolean;
    private static iosDevice: boolean | null = null;
    static clientLanguageString: any;

    static isSafari(): boolean {
        return (
            navigator.vendor !== undefined &&
            navigator.vendor !== null &&
            navigator.vendor.indexOf("Apple") > -1 &&
            navigator.userAgent !== undefined &&
            navigator.userAgent !== null &&
            navigator.userAgent.indexOf("CriOS") == -1 &&
            navigator.userAgent.indexOf("FxiOS") == -1
        );
    }
    static getIosVersion() {
        const match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);

        if (match !== undefined && match !== null) {
            const version = [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || "0", 10)];
            return parseFloat(version.join("."));
        }
        return 0;
    }

    static isSafariAndSupportPushNotifications(): boolean {
        const isIosDevice = Misc.isIosDevice();
        if (isIosDevice === true) {
            const iosVersion = Misc.getIosVersion();
            if (iosVersion >= 16.4) {
                if (Misc.isSafari() === true) {
                    return true;
                }
            }
        }

        return false;
    }
    static isIosDevice(): boolean {
        if (this.iosDevice == null) this.iosDevice = /iPad|iPhone|iPod/.test(navigator.platform);
        return this.iosDevice;
    }

    static isPrivateMode(): Promise<boolean> {
        const isNewChrome = () => {
            const pieces = navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\.([0-9]+)\.([0-9]+)\.([0-9]+)/);
            if (pieces == null || pieces.length != 5) return undefined;
            const major = pieces.map((piece) => parseInt(piece, 10))[1];
            if (major >= 76) return true;
            return false;
        };
        const chrome76Detection = async () => {
            if ("storage" in navigator && "estimate" in navigator.storage) {
                const { quota } = await navigator.storage.estimate();
                if (quota != null && quota < 120000000) return true;
                else return false;
            } else {
                return false;
            }
        };
        return new Promise((resolve) => {
            if (Misc.privateSurfing !== undefined) {
                resolve(Misc.privateSurfing);
                return;
            }
            try {
                const isSafari =
                    navigator.vendor &&
                    navigator.vendor.indexOf("Apple") > -1 &&
                    navigator.userAgent &&
                    navigator.userAgent.indexOf("CriOS") == -1 &&
                    navigator.userAgent.indexOf("FxiOS") == -1;
                if (isSafari) {
                    //Safari
                    let e = false;
                    if (window["safariIncognito"]) {
                        e = true;
                    } else {
                        try {
                            window["openDatabase"](null, null, null, null);
                            window.localStorage.setItem("test", "1");
                            Misc.privateSurfing = false;
                            resolve(false);
                        } catch (ex) {
                            e = true;
                            Misc.privateSurfing = true;
                            resolve(true);
                        }
                        (e = !1), window.localStorage.removeItem("test");
                    }
                } else if (navigator.userAgent.includes("Firefox")) {
                    //Firefox
                    const db = indexedDB.open("test");
                    db.onerror = () => {
                        Misc.privateSurfing = true;
                        resolve(true);
                    };
                    db.onsuccess = () => {
                        Misc.privateSurfing = false;
                        resolve(false);
                    };
                } else if (
                    navigator.userAgent.includes("Edge") ||
                    navigator.userAgent.includes("Trident") ||
                    navigator.userAgent.includes("msie")
                ) {
                    //Edge or IE
                    if (!window.indexedDB && (window.PointerEvent || window["MSPointerEvent"])) {
                        Misc.privateSurfing = true;
                        resolve(true);
                        return;
                    }
                    Misc.privateSurfing = false;
                    resolve(false);
                } else {
                    //Normally ORP or Chrome
                    //Other
                    if (isNewChrome()) resolve(chrome76Detection());
                    const fs = window["RequestFileSystem"] || window["webkitRequestFileSystem"];
                    if (!fs) {
                        Misc.privateSurfing = false;
                        resolve(false);
                    } else {
                        fs(
                            window["TEMPORARY"],
                            100,
                            () => {
                                Misc.privateSurfing = false;
                                resolve(false);
                            },
                            () => {
                                Misc.privateSurfing = true;
                                resolve(true);
                            }
                        );
                    }
                }
            } catch (ex) {
                Misc.privateSurfing = false;
                resolve(false);
            }
        });
    }
    static eachEnum(enumType, cb: { (i: number, value: string): boolean | void }) {
        for (const i in enumType) {
            const it = parseInt(i);
            if (!isNaN(it)) {
                const continueTok = cb(it, enumType[i]);
                if (continueTok !== undefined && continueTok === false) break;
            }
        }
    }
    static enumsToStringArray(enumType: any, values: Array<number>): Array<string> {
        const mapped = new Array<string>();
        for (const i in values) mapped.push(enumType[values[i]]);
        return mapped;
    }
    static enumsToValueNameArray<T>(enumType: T) {
        const values: Array<EnumValueNamePair> = [];

        Misc.eachEnum(enumType, (value, name) => {
            values.push({
                value: value,
                name: name,
            });
        });

        return values;
    }
    static padDigits(value, digits): string {
        return Array(Math.max(digits - String(value).length + 1, 0)).join("0") + value;
    }
    static roundCents(price: number): number {
        return Math.round(price * 100 + Number.EPSILON) / 100;
    }
    static roundFiftyCents(price: number): number {
        return Math.round(price * 2) / 2;
    }
    static parseFloat(fl?: number, meridian?: number): number | undefined {
        if (fl === undefined || fl == null) return undefined;
        if (meridian === undefined) meridian = 2;
        return Math.round(parseFloat((fl * Math.pow(10, meridian)).toFixed(meridian))) / Math.pow(10, meridian);
    }
    static byteToReadableString(bytes: number): string {
        const kBytes = bytes / 1024;
        if (kBytes < 900) return kBytes.toFixed(1) + "kB";
        else return (kBytes / 1024).toFixed(1) + "MB";
    }
}
